// @flow
import type { Node, ComponentType } from 'react';
import React from 'react';
import { Panel } from 'rc-collapse';

import Header from '../Header';
import Content from '../Content';

import styles from './panel.css';


type PanelProps = {
  title: Node,
  badgeCount?: number,
  ActionIcon?: ComponentType<*>,
  action?: Function,
  removeContentPadding?: boolean,
  ActionComponent?: ComponentType<*>,
  children?: Node,
};

export default ({
  title,
  badgeCount = 0,
  ActionIcon,
  action,
  removeContentPadding = false,
  ActionComponent,
  children,
  ...props
}: PanelProps) => (
  <Panel
    className={styles.panel}
    {...props}
    header={
      <Header
        title={title}
        badgeCount={badgeCount}
        ActionIcon={ActionIcon}
        ActionComponent={ActionComponent}
        action={action}
      />
    }
  >
    <Content clearPaddings={removeContentPadding}>
      { children }
    </Content>
  </Panel>
);



// WEBPACK FOOTER //
// ./src/scripts/components/Accordion/Panel/index.jsx